import { render } from "./RollHistoryElement.vue?vue&type=template&id=75d04bca&scoped=true"
import script from "./RollHistoryElement.vue?vue&type=script&lang=js"
export * from "./RollHistoryElement.vue?vue&type=script&lang=js"

import "./RollHistoryElement.vue?vue&type=style&index=0&id=75d04bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d04bca"]])

export default __exports__